import { render, staticRenderFns } from "./Devolucion.vue?vue&type=template&id=2e13e55c&scoped=true&"
import script from "./Devolucion.vue?vue&type=script&lang=js&"
export * from "./Devolucion.vue?vue&type=script&lang=js&"
import style0 from "./Devolucion.vue?vue&type=style&index=0&id=2e13e55c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e13e55c",
  null
  
)

export default component.exports